module.exports = __webpack_public_path__ + "media/soundtrack.fa495d49.mp3";